import { render, staticRenderFns } from "./newAreaList.vue?vue&type=template&id=5fd7b87c&scoped=true"
import script from "./newAreaList.vue?vue&type=script&lang=js"
export * from "./newAreaList.vue?vue&type=script&lang=js"
import style0 from "./newAreaList.vue?vue&type=style&index=0&id=5fd7b87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd7b87c",
  null
  
)

export default component.exports